export const AI_STYLES = [
  { id: "outline", label: "Outline", description: "Just the essential lines." },
  { id: "standard", label: "Standard", description: "Structure with finer detail." },
  { id: "hatching", label: "Hatching", description: "Lines with shading guides." },
] as const;

export type AiStyle = typeof AI_STYLES[number]["id"];
export type ArtworkView = "original" | "compare" | "stencil";
export interface AiSourceAsset {
  id: string;
  name: string;
  url: string;
  width: number;
  height: number;
  example: boolean;
  bytes?: Uint8Array;
  mediaType?: "image/png" | "image/jpeg";
}
export interface AiSource extends AiSourceAsset {
  /** The untouched upload retained when a local preparation raster is used. */
  original?: AiSourceAsset;
}
export interface AiResult {
  bytes?: Uint8Array;
  mediaType?: "image/png" | "image/jpeg";
  id: string;
  source: AiSource;
  url: string;
  width: number;
  height: number;
  style: AiStyle;
  instructions: string;
  createdAt: number;
  example: boolean;
}

const asset = (file: string) => `${import.meta.env.BASE_URL}ai-examples/${file}.png`;
export const EXAMPLE_SOURCE: AiSource = {
  id: "peony-example", name: "Peony study", url: asset("peony-reference"), width: 1024, height: 1536, example: true,
};
export function exampleResult(style: AiStyle): AiResult {
  return { id: `example-${style}`, source: EXAMPLE_SOURCE, url: asset(`peony-${style}`), width: 1024, height: 1536, style, instructions: "", createdAt: 0, example: true };
}

export function isAiStyle(value: unknown): value is AiStyle {
  return AI_STYLES.some(style => style.id === value);
}
